/* Const,Let & Var will be here */
export const SAVE_PROJECT_AND_TASK = 'SAVE_PROJECT_AND_TASK';

/* Const,Let & Var will be here */

export function saveProjectAndTask(project, task) {
    return {
        type: SAVE_PROJECT_AND_TASK,
        project: project,
        task: task
    };
}